export default Object.freeze({
  PREVIOUS: '이전 버전 보기',
  NEXT: '다음 버전 보기',
})